/**
 * @generated SignedSource<<8824b48713bbf842eeabdf2a616a9d82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleRoutineListItemContent_Routine$data = {
  readonly description: string | null;
  readonly descriptionImages: ReadonlyArray<{
    readonly size: {
      readonly url: string;
    } | null;
  }>;
  readonly id: string;
  readonly isOrg: boolean;
  readonly orgIconUri: string | null;
  readonly title: string;
  readonly " $fragmentType": "WidgetTeamScheduleRoutineListItemContent_Routine";
};
export type WidgetTeamScheduleRoutineListItemContent_Routine$key = {
  readonly " $data"?: WidgetTeamScheduleRoutineListItemContent_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineListItemContent_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleRoutineListItemContent_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 120
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 120
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "size(minHeight:120,minWidth:120)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "23d6ef3895816867b6f8dba120893099";

export default node;
